const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoDriverVisionTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.40449 14.6359C8.40449 15.1359 7.99919 15.5412 7.49922 15.5412C6.99925 15.5412 6.59395 15.1359 6.59395 14.6359C6.59395 14.136 6.99925 13.7307 7.49922 13.7307C7.99919 13.7307 8.40449 14.136 8.40449 14.6359Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4875 15.5412C16.9875 15.5412 17.3928 15.1359 17.3928 14.6359C17.3928 14.136 16.9875 13.7307 16.4875 13.7307C15.9875 13.7307 15.5822 14.136 15.5822 14.6359C15.5822 15.1359 15.9875 15.5412 16.4875 15.5412Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95465 6.22668C6.04312 5.96126 6.29151 5.78223 6.57129 5.78223H17.4271C17.7069 5.78223 17.9553 5.96126 18.0438 6.22668L20.0159 12.1429C20.038 12.2092 20.0492 12.2786 20.0492 12.3485V19.3222C20.0492 19.6315 19.7985 19.8822 19.4892 19.8822H19.1759C18.8666 19.8822 18.6159 19.6315 18.6159 19.3222V18.3822H5.38255V19.3222C5.38255 19.6315 5.13183 19.8822 4.82255 19.8822H4.50922C4.19994 19.8822 3.94922 19.6315 3.94922 19.3222V12.3485C3.94922 12.2786 3.96048 12.2092 3.98257 12.1429L5.95465 6.22668ZM5.04922 17.2822H18.9492V12.4215L18.7695 11.8822H5.22897L5.04922 12.4215V17.2822ZM5.59564 10.7822H18.4028L17.1028 6.88223H6.89564L5.59564 10.7822Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoDriverVisionTest);
export default __webpack_public_path__ + "static/media/bo-driver-vision-test.dc9520524a8a1e940d45f35a2de8db6a.svg";
export { ForwardRef as ReactComponent };